import {MapContentSource} from './MapContentSource';
import {LayerSpecification} from 'maplibre-gl';
import { MapContentVectorSource } from './MapContentVectorSource';

export abstract class MapContentLayer {

  protected constructor(
    public layerId: string,
    protected sourceRef: MapContentSource | MapContentVectorSource,
  ) {}

  abstract toLayerSpecification(): LayerSpecification;
}
